import {
  GAME_ID,
  SELECT_LEVEL,
  NUM_LEVELS,
  ADD_TO_CORRECT_COUNT,
  FINISH_ROUND,
} from '../../data/punchlineConstants';

const initialState = {
  correctAnswersCount: 0,
  lastLevelUnlocked: 0,
  currentLevel: 0,
};

const punchlineSessionReducer = (state = initialState, action) => {
  if (action.type === 'SELECT_ACTIVITY' && action.payload.activity === GAME_ID) {
    return initialState;
  }
  if (action.gameId !== GAME_ID) {
    return state;
  }
  switch (action.type) {
    case SELECT_LEVEL:
      return {
        ...state,
        correctAnswersCount: 0,
        currentLevel: action.payload,
      };
    case ADD_TO_CORRECT_COUNT: {
      return {
        ...state,
        correctAnswersCount: state.correctAnswersCount + 1,
      };
    }
    case FINISH_ROUND: {
      // if onboarding, bail out
      if (state.currentLevel === -1) {
        return state;
      }
      const { level, isMastered } = action.payload;
      let { lastLevelUnlocked } = state;
      if (isMastered) {
        lastLevelUnlocked = Math.min(level + 1, NUM_LEVELS - 1);
      }

      return {
        ...state,
        lastLevelUnlocked,
      };
    }
    default:
      return state;
  }
};

export default punchlineSessionReducer;
